import * as $ from 'jquery';

export default class EmailSig {
	constructor() {
		if (!document.getElementById('generateSigForm')) return;

		var PRI: any = {};

		PRI.signature = (function($){

			const selectText = function(element: any) {
				const doc = document;
				const selection = window.getSelection();
				const range = doc.createRange();
				range.selectNodeContents(element);
				selection.removeAllRanges();
				selection.addRange(range);
			}

			const company = {
				name: 'LandBridge Capital',
				tel: '(212) 220-8596',
				tel800: '(800) 657-2597',
				email: 'info@landbridgecapital.com',
				website: {
					url: 'http://www.landbridgecapital.com/',
					text: 'www.landbridgecapital.com'
				}
			};

			const baseHref = $('base').attr('href');

			/**
			 * Factory for phone number output
			 * @param {object[]} phones The person's phone numbers
			 * @param {object} styles Form styling
			 * @return {string}
			 */
			function buildPhone(phones: any, styles: any) {
				var output = [];

				for (var i = 0; i < phones.length; i++) {
					if (phones[i].value) {
						output.push(
							'<tr>'
							+'<td colspan="2" style="padding-top: 3px; padding-bottom: 0;">'
							+'<span style="'+styles.b+'">' + phones[i].initial.toUpperCase() + ' </span>'
							+'<span style="white-space: nowrap;"><a href="tel: '+ phones[i].value +'" style="'+styles.a+'">'+ phones[i].value +'</a></span>'
							+'</td>'
							+'</tr>'
						);
					}
				}
				return output.join('');
			}

			var generateSig = function( person: any ){
				var colorBlue = '#50596c';
				var styles = {
					a: 'color: '+colorBlue+'; font-weight:normal; text-decoration: none;',
					b: 'color: '+colorBlue+';font-weight:bold;'
				};

				var name = person.name || 'YOUR NAME HERE';
				var title = person.title || '';
				var number = buildPhone(person.phones, styles);
				var email = person.email || company.email;

				var html = '<table class="emailSignatureTable" border="0" cellspacing="0" cellpadding="0" bgcolor="white">'
				+'	<tr>'
				+'		<td width="360">'
				+'			<table border="0" cellspacing="0" cellpadding="0" style="font-family: Georgia, serif; font-size: 12px;">'
				+'				<tr><td colspan="2" style="padding-bottom: 20px;"><span style="font-size: 16px; font-family: georgia, times, serif;color: '+colorBlue+'">' + 'Regards,' + '</span></td></tr>'
				+'				<tr><td colspan="2" valign="bottom"><span style="font-size: 18px; font-weight: bold; font-family: georgia, times, serif;color: '+colorBlue+'">' + name.toUpperCase() + '</span></td></tr>'
				+'				<tr><td colspan="2" valign="bottom" style="padding-bottom: 20px;padding-top:0;"><span style="font-size: 13px; font-family: georgia, times, serif;color: '+colorBlue+'">' + title.toUpperCase() + '</span></td></tr>'
				+				number
				+'				<tr>'
				+'					<td colspan="2" style="padding-top: 3px">'
				+'<span style="'+styles.b+'">E </span><span style="white-space: nowrap;"><a href="mailto: '+ email +'" style="'+styles.a+'">'+ email +'</a><span></span>'
				+'					</td>'
				+'				</tr>'
				+'				<tr>'
				+'					<td colspan="2" style="padding-top: 10px">'
				+'					  <img src="' + baseHref + 'email-signature/images/blue-bar.gif" height="2" width="96" style="display: block;" />'
				+'					</td>'
				+'				</tr>'
				+'				<tr>'
				+'					<td colspan="2" style="padding-top: 20px; padding-bottom: 10px">'
				+'						<a href="'+company.website.url+'" style="'+styles.a+'">'
				+'							<img src="' + baseHref + 'email-signature/images/email-signature.png" alt="' + company.name + '" height="44" width="360" style="display: block;" />'
				+'						</a>'
				+'					</td>'
				+'        </tr>'
				+'        <tr>'
				+'					<td style="padding-top: 3px">'
				+'						<span style="font-size: 9px;' + styles.a + '">One World Trade Center<br />Suite 8500<br />New York, NY 10007</span>'
				+'					</td>'
				+'					<td style="padding-top: 3px;text-align: right;" valign="top">'
			+'						<a href="tel:' + company.tel.replace(/\D/g, '') + '" style="font-size: 9px;display: block;'+ styles.a + '">' + company.tel + '</a>'
			+'						<a href="tel:' + company.tel800.replace(/\D/g, '') + '" style="font-size: 9px;display: block;'+ styles.a + '">' + company.tel800 + '</a>'
				+'					</td>'
				+'				</tr>'
				+'			</table>'
				+'		</td>'
				+'	</tr>'
				+'</table>';
				return html;
			};

			var sigForm: any;
			var sigArea: any;
			var pub = {
				setup: function() {
					sigForm = $('#generateSigForm');
					sigArea = $("#signature");

					function changeit(){
						var person = {
							name: sigForm.find("[name='name']").val(),
							title: sigForm.find('[name="title"]').val(),
							phones: [
								{initial: 'p', value: sigForm.find("[name='phone']").val()},
								{initial: 'm', value: sigForm.find("[name='mobile']").val()},
								{initial: 'c', value: sigForm.find("[name='cell']").val()},
								{initial: 'o', value: sigForm.find("[name='office']").val()}
							],
							email: sigForm.find('[name="email"]').val()
						}

						// NOTE: Uncomment for quick testing of layout/appearance
						// person =
						// 	name: 'Scott Wetzel, JD AIF',
						// 	title: 'Managing Partner',
						// 	direct: '(612) 760-4444',
						// 	email: 'Scott.Wetzel@landbridgecapital.com'
						// }

						sigArea.html(generateSig( person ));
						return false; // Stop form from submitting.
					}
					sigForm.on('change', changeit);
					sigForm.on('submit', changeit);

					$('#selectSignature').click(function(){
						selectText( sigArea.get(0) );
					});
				}
			};

			return pub;

		})($);


		$(function(){
			PRI.signature.setup();
		});
	}
}
